export default "__VITE_ASSET__FF4eQ3ER__"